var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-task-history" },
    [
      _c("h3", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("automation.autoPlanAndTaskHistory"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("a-input-search", {
                  staticClass: "row search-input",
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: _vm.$t("message.search") },
                  on: {
                    input: function ($event) {
                      return _vm.onSearch($event.target.value)
                    },
                  },
                  model: {
                    value: _vm.searchText,
                    callback: function ($$v) {
                      _vm.searchText = $$v
                    },
                    expression: "searchText",
                  },
                }),
                _vm._v(" "),
                _c("CommonFilterTool", {
                  attrs: {
                    "keep-state-on-query-params": false,
                    "filter-meta": _vm.filterMetas,
                    "label-formatter": _vm.filterLabelFormatter,
                  },
                  on: { addFilter: _vm.addFilter },
                  model: {
                    value: _vm.breakdownFilter,
                    callback: function ($$v) {
                      _vm.breakdownFilter = $$v
                    },
                    expression: "breakdownFilter",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm.checkboxOption.selectedRowKeys.length > 0
                  ? _c(
                      "SupsisButton",
                      {
                        attrs: { danger: "" },
                        on: { click: _vm.confirmCancelSelected },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("cancel"),
                        ]),
                        _vm._v(
                          "\n                    Seçili Planları İptal Et\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.items,
              "top-pagination": "",
              "empty-data-bordered": "",
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                checkboxOption: _vm.checkboxOption,
                rowStyleOption: _vm.rowStyleOption,
                clipboardOption: _vm.clipboardOption,
                fixedHeader: true,
                id: "automation-table",
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPayloadModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.payloadModalTitle,
                showFooter: false,
                xlarge: "",
              },
              on: { cancel: _vm.closePayloadModal },
            },
            [
              _c(
                "div",
                { staticClass: "payload-modal-content" },
                [
                  _c("v-jsoneditor", {
                    attrs: { options: _vm.jsonEditorOptions, height: "500px" },
                    model: {
                      value: _vm.selectedPayload,
                      callback: function ($$v) {
                        _vm.selectedPayload = $$v
                      },
                      expression: "selectedPayload",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTaskTraceModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Task Trace & Review",
                showFooter: false,
                xlarge: "",
              },
              on: { cancel: _vm.closeTaskTraceModal },
            },
            [
              _vm.selectedTask && _vm.selectedPlan
                ? _c("TaskTraceViewer", {
                    attrs: { task: _vm.selectedTask, plan: _vm.selectedPlan },
                    on: { showPayload: _vm.openPayloadModalFromTrace },
                  })
                : _c("div", { staticClass: "no-task-message" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("info"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Bu plan için henüz bir task oluşturulmamış."),
                    ]),
                  ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }